import { FC, ReactNode } from "react";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { useCustomerEnvironmentNameOrThrow } from "firefly-shared-ts-customer-environment";
import { useCustomerSettingsDao } from "./useCustomerSettingsDao";
import { CustomerSettingsDto } from "./CustomerSettings";

export interface CustomerSettingsLoaderProps {
  children: (
    customerSettingsQueryResult: UseQueryResult<CustomerSettingsDto, Error>
  ) => ReactNode;
}

export const CustomerSettingsLoader: FC<CustomerSettingsLoaderProps> = (
  props
) => {
  const customerEnvironmentId = useCustomerEnvironmentNameOrThrow();
  const customerSettingsDao = useCustomerSettingsDao();

  const customerSettingsQueryResult = useQuery({
    queryKey: [customerEnvironmentId],
    queryFn: () => customerSettingsDao.getById(),
    placeholderData: (previousData, previousQuery) => previousData,
    staleTime: 10 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
  });

  return <>{props.children(customerSettingsQueryResult)}</>;
};
